"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _Button = _interopRequireDefault(require("elevate-ui/Button"));

var _Save = _interopRequireDefault(require("elevate-ui-icons/Save"));

var Submit = function Submit(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    className: className,
    icon: /*#__PURE__*/_react["default"].createElement(_Save["default"], null),
    color: "secondary",
    type: "submit"
  }, "Save");
};

var _default = Submit;
exports["default"] = _default;